import { IPropertyField } from '../../../entities/common';

export default function filterFields(fields: IPropertyField[], filterKeys: string[]) {
	return fields.filter(f => filterKeys.indexOf(f.name) == -1);
}
